import { render, staticRenderFns } from "./UniversityReport.vue?vue&type=template&id=51cfbfae&"
import script from "./UniversityReport.vue?vue&type=script&lang=js&"
export * from "./UniversityReport.vue?vue&type=script&lang=js&"
import style0 from "./UniversityReport.vue?vue&type=style&index=0&id=51cfbfae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports